import * as React from "react";
import { HyperLinkMenu } from "@models/hyperLinkMenu";
import { Button, Divider, Modal, Table, Avatar } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import Message from "@constants/message";
import { PaginationDefaultParams } from "../custom/Paginator";
import { HyperLinkMenuLocationOptions } from "@models/hyperLinkMenu";
import { NavLink } from "react-router-dom";

type Props = {
  data: HyperLinkMenu[];
  loading: boolean;
  deleteFn: (item: HyperLinkMenu) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const CategoriesTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteHyperLinkMenu = (item: HyperLinkMenu): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: (
        <FormattedMessage
          id="app.display_title"
          defaultMessage={`Display Title`}
        />
      ),
      dataIndex: "display_title",
      key: "display_title"
    },
    {
      title: (
        <FormattedMessage
          id="app.display_location"
          defaultMessage={`Location`}
        />
      ),
      dataIndex: "location",
      key: "location",
      render: location =>
        HyperLinkMenuLocationOptions.find(hl => hl.value == location).label
    },
    {
      title: (
        <FormattedMessage id="app.platforms" defaultMessage={`Platforms`} />
      ),
      dataIndex: "platforms",
      key: "platforms"
    },
    {
      title: (
        <FormattedMessage
          id="app.display_order"
          defaultMessage={`Display Order`}
        />
      ),
      dataIndex: "order",
      key: "order"
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`status`} />,
      dataIndex: "is_active",
      key: "is_active",
      render: is_active => {
        return is_active ? (
          <FormattedMessage id="app.active" defaultMessage={`Active`} />
        ) : (
          <FormattedMessage id="app.inactive" defaultMessage={`Inactive`} />
        );
      }
    },
    {
      title: "",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/hyperLinkMenus/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteHyperLinkMenu(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(CategoriesTable);
